var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1137",
    "data-name": "Group 1137",
    transform: "translate(-3099 -654)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1136",
    "data-name": "Group 1136"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_639",
    "data-name": "Path 639",
    d: "M3100.185,669.315a.5.5,0,0,1-.354-.853l13.631-13.631a.5.5,0,0,1,.707.707l-13.631,13.631A.5.5,0,0,1,3100.185,669.315Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_640",
    "data-name": "Path 640",
    d: "M3113.815,669.315a.5.5,0,0,1-.353-.146l-13.631-13.631a.5.5,0,0,1,.707-.707l13.631,13.631a.5.5,0,0,1-.354.853Z"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_486",
    "data-name": "Rectangle 486",
    width: 16,
    height: 16,
    transform: "translate(3099 654)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon-close.f7d1fe32eed8668ccf122888c67a5cc6.svg";
export { ForwardRef as ReactComponent };